const actions = {
    GET_WORKSPACE_BY_CUSTOMER_ID: "customerWorkspace/GET_WORKSPACE_BY_CUSTOMER_ID",
    SET_WORKSPACE_BY_CUSTOMER_ID: "customerWorkspace/SET_WORKSPACE_BY_CUSTOMER_ID",

    GET_CUSTOMER_BY_WORKSPACE_ID: "customerWorkspace/GET_CUSTOMER_BY_WORKSPACE_ID",
    SET_CUSTOMER_BY_WORKSPACE_ID: "customerWorkspace/SET_CUSTOMER_BY_WORKSPACE_ID",
};

export default actions